import React from "react";
import { CHART_THEME, iChartTheme } from "./useChartTheme";

export const ChartThemeContext = React.createContext({ THEME: CHART_THEME.DARK } as { THEME: iChartTheme });